import React, { ReactNode } from 'react';
import CheckBoxWithLabel from '../../components/checkbox/CheckBoxWithLabel';

interface RenderTopBarExtrasProps {
    type: string;
    mnoOptions?: Array<{ id: string; name: string }>;
    selectedMnos?: string[];
    handleMnoCheckbox?: (mnoName: string, checked: boolean) => void;
    entireResponse?: any;
    reversalActiveTab?: 'recharge-reversal' | 'etopup-stock-digital-wallet-reversal';
    handleReversalTabSwitch?: (tab: 'recharge-reversal' | 'etopup-stock-digital-wallet-reversal') => void;
}

export const renderTopBarExtrasByType = (props: RenderTopBarExtrasProps): ReactNode => {
    const { type } = props;
    switch (type) {
        case 'MNO Wise eTop Up Purchase Report':
            return renderMnoWiseEtopupPurchaseTopBar(props);
            
        case "MNO's Service Fee Earned Report":
            return renderMnoServiceFeeEarnedTopBar(props);

        case 'Upfront Purchase Report':
            // MNO filter is handled via radio buttons in the filter panel, not in top bar
            return null;

        case 'Reversal Report':
            return renderReversalReportTopBar(props);

        default:
            return null;
    }
};

const renderMnoWiseEtopupPurchaseTopBar = (props: RenderTopBarExtrasProps): ReactNode => {
    const { mnoOptions = [], selectedMnos = [], handleMnoCheckbox } = props;

    if (!mnoOptions.length) return null;

    return (
        <div className="flex flex-wrap gap-4 pt-4 px-[13px] rounded-lg">
            <CheckBoxWithLabel
                label="All"
                checked={selectedMnos.includes('All')}
                handelCheckBox={handleMnoCheckbox || (() => { })}
            />
            {mnoOptions.map((mno) => (
                <CheckBoxWithLabel
                    key={mno.id}
                    label={mno.name}
                    checked={selectedMnos.includes('All') || selectedMnos.includes(mno.id)}
                    handelCheckBox={handleMnoCheckbox || (() => { })}
                />
            ))}
        </div>
    );
};

const renderReversalReportTopBar = (props: RenderTopBarExtrasProps): ReactNode => {
    const { reversalActiveTab = 'recharge-reversal', handleReversalTabSwitch } = props;

    return (
        <div className="flex flex-row gap-6 pt-4 pb-2 px-4">
            <div
                className={`text-subTitle cursor-pointer ${
                    reversalActiveTab === 'recharge-reversal'
                        ? 'text-p_primary border-b-2 border-p_primary'
                        : 'text-gray-400 border-b-2 border-gray-400'
                }`}
                onClick={() => handleReversalTabSwitch && handleReversalTabSwitch('recharge-reversal')}
            >
                Recharge Reversal
            </div>
            <div
                className={`text-subTitle cursor-pointer ${
                    reversalActiveTab === 'etopup-stock-digital-wallet-reversal'
                        ? 'text-p_primary border-b-2 border-p_primary'
                        : 'text-gray-400 border-b-2 border-gray-400'
                }`}
                onClick={() => handleReversalTabSwitch && handleReversalTabSwitch('etopup-stock-digital-wallet-reversal')}
            >
                eTop Up Stock/Digital Wallet Reversal
            </div>
        </div>
    );
};

const renderMnoServiceFeeEarnedTopBar = (props: RenderTopBarExtrasProps): ReactNode => {
    const { entireResponse } = props;

    if (!entireResponse?.service_fee_summary) return null;

    return (
        <div className="mt-4 px-4">
            <div className="rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-gray-800">
                    Summary
                </h3>
                <div className="flex overflow-auto scrollHide pb-2 gap-4">
                    <div
                        className="bg-[#E7EDF5] rounded-md p-3 border border-gray-200 w-[292px] flex-shrink-0"
                    >
                        <div className='flex flex-col gap-1 justify-center items-center'>
                            <span className="text-body2 text-center text-gray-500">Total Upfront Service Fee Earned</span>
                            <span className="font-bold text-gray-700">
                                {entireResponse.service_fee_summary.upfront_service_fee_earned ? `AFA ${entireResponse.service_fee_summary.upfront_service_fee_earned.toFixed(2)}` : "AFA 0.00"}
                            </span>
                        </div>
                    </div>
                    <div
                        className="bg-[#E7EDF5] rounded-md p-3 border border-gray-200 w-[292px] flex-shrink-0"
                    >
                        <div className='flex flex-col gap-1 justify-center items-center'>
                            <span className="text-body2 text-center text-gray-500">Total On Target Service Fee Earned</span>
                            <span className="font-bold text-gray-700">
                                {entireResponse.service_fee_summary.on_target_achievement_service_fee_earned ? `AFA ${entireResponse.service_fee_summary.on_target_achievement_service_fee_earned.toFixed(2)}` : "AFA 0.00"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};